<template>
    <!-- 首页 3 -->
    <div class="contents section-hero">
        <div class="container">
            <div class="container_box row col-lg-12">
                <h2>{{ $t("homeThree.title") }}</h2>
                <h2>{{ $t("homeThree.subtitle") }}</h2>
                <div class="container_box_img row">
                    <div class="col-3" v-for="(value, index) in contents" :key="index">
                        <div class="box_img_div">
                            <img :src="value.img" class="card-img">
                            <div class="box_img_div_text">
                                <p>{{ value.title }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'homeThree',
    data() {
        return {
        };
    },
    computed: {
        contents() {
            return [
                {
                    img: '/img/pay/0--80.png',
                    title: this.$t('homeThree.description1'),
                },
                {
                    img: '/img/pay/0--81.png',
                    title: this.$t('homeThree.description2'),
                },
                {
                    img: '/img/pay/0--82.png',
                    title: this.$t('homeThree.description3'),
                },
                {
                    img: '/img/pay/0--83.png',
                    title: this.$t('homeThree.description4'),
                }
            ]
        }
    },
};
</script>
<style scoped lang="scss">
.contents {
    background-image: url('/img/pay/0--87.png');
    background-position: center;
    // background-repeat: no-repeat;
    background-size: cover;
    height: var(--main-height);

}

.container {
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    .container_box {
        flex-direction: column;
        margin-top: 150px;
        // align-items: center;

        h2 {
            font-weight: 800;
            color: #233dd2;

        }

        h2:first-child {
            margin-bottom: 15px;
            color: #333;
        }

        .container_box_img {
            margin-top: 150px;
            display: flex;

            .col-3 {

                // PC端：四段展示 (col-3 表示 25% 宽度)
                @media (max-width: 768px) {
                    // 手机端：两段展示 (col-6 表示 50% 宽度)
                    flex: 0 0 50%;
                    max-width: 50%;
                }

                @media (max-width: 576px) {
                    // 更小的手机屏幕：两段展示，增加间距
                    flex: 0 0 50%;
                    max-width: 50%;
                    margin-bottom: 1rem;
                }
            }

            .box_img_div {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                // background-color: #233dd2;
                // display: flex;
                .box_img_div_text {
                    position: absolute;
                    inset: 0;
                    display: flex;
                    align-items: center;

                    p {
                        // font-size: 18px;
                        // font-size: .8em;
                        color: white;
                        margin: 0;
                        margin-left: 33%;
                    }
                }
            }
        }
    }
}

.card {
    border-radius: 100px;
}
</style>
